let defaultFaviconHref = null

function ensureFaviconLink () {
  let faviconLink = document.querySelector("link[rel~='icon']")

  if (!faviconLink) {
    faviconLink = document.createElement('link')
    faviconLink.setAttribute('rel', 'icon')
    document.head.appendChild(faviconLink)
  }

  if (defaultFaviconHref === null) {
    defaultFaviconHref = faviconLink.getAttribute('href')
  }

  return faviconLink
}

export function setDocumentFavicon (faviconUrl) {
  const faviconLink = ensureFaviconLink()

  if (faviconUrl) {
    faviconLink.setAttribute('href', faviconUrl)
    return
  }

  if (defaultFaviconHref) {
    faviconLink.setAttribute('href', defaultFaviconHref)
  }
}
